import { AuthActions, useFetcherResult, useLocalePath } from "@commercekit/remix";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";
import WvButton from "../atoms/WvButton";
import WvFormHiddenInputs from "../atoms/WvFormHiddenInputs";

const WvCustomerLogoutForm = ({ className }: { className?: string }) => {
  const { $pt } = usePrismicLabels();
  const localePath = useLocalePath();
  const {
    isLoading: loggingOut,
    fetcher: { Form },
  } = useFetcherResult();

  return (
    <Form
      action={localePath("/customer/logout")}
      method="post"
      reloadDocument
      className={className}
    >
      <WvFormHiddenInputs
        data={{
          _action: AuthActions.LOGOUT,
          redirect: localePath("/customer/login"),
          _root_refresh: true,
        }}
      />
      <WvButton
        className={`${
          loggingOut ? "js-cm-logout" : ""
        } btn w-100 text-nowrap`}
        type="submit"
        data-icon-before={"\uf1af"}
        disabled={loggingOut}
      >
        {$pt("profile_logout_cta_name")}
      </WvButton>
    </Form>
  );
};

export default WvCustomerLogoutForm;
